import type { FileDocumentKind } from '@teo/widget-shared';

type FileTypeIconProps = {
  kind: FileDocumentKind;
  className?: string;
};

const LABELS: Record<FileDocumentKind, string> = {
  pdf: 'PDF',
  word: 'DOC',
  excel: 'XLS',
  presentation: 'PPT',
  archive: 'ZIP',
  text: 'TXT',
  generic: 'FILE',
};

export function FileTypeIcon({ kind, className }: FileTypeIconProps) {
  return (
    <span
      className={`teo-rich-media__file-icon teo-rich-media__file-icon--${kind}${className ? ` ${className}` : ''}`}
      aria-hidden
    >
      {LABELS[kind]}
    </span>
  );
}
